import { render, staticRenderFns } from "./ShareAccess.vue?vue&type=template&id=55be4e84&scoped=true"
import script from "./ShareAccess.vue?vue&type=script&lang=js"
export * from "./ShareAccess.vue?vue&type=script&lang=js"
import style0 from "./ShareAccess.vue?vue&type=style&index=0&id=55be4e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be4e84",
  null
  
)

export default component.exports